import moment from 'moment';

export default (data, activity) => {
  const date = moment(data.date || undefined).format('YYYY-MM-DD');

  if (data.flag) {
    return {
      id: activity ? activity.id : undefined,

      video: {
        caption: data.caption
      },

      daily_activity: {
        is_staff_only: data.staffOnly,
        activity_time: `${date} ${data.time}`,
        comment: data.caption
      }
    };
  } else {
    return {
      id: activity ? activity.id : undefined,

      video: {
        caption: data.caption
      },

      daily_activity: {
        is_staff_only: data.staffOnly
      }
    };
  }
};
